import { Survey } from '../../interfaces/survey.interface';

// survey.company may be a bare id or a nested Company object.
export function resolveSurveyCompanyId(survey: Pick<Survey, 'company'>): number | undefined {
  return typeof survey.company === 'number' ? survey.company : survey.company?.id;
}

// Refetch when the loaded company differs from the survey's by id, not merely when absent (TPE-2704: a stale SP company left the modal PDF generating for the wrong SP).
export function shouldRefetchSurveyCompany(
  surveyCompanyId: number | undefined,
  loadedCompanyId: number | undefined,
): boolean {
  if (!surveyCompanyId) return false;
  return loadedCompanyId !== surveyCompanyId;
}
